import ModalBundleDomain from "components/ModalBundleDomain";
import DomainSuggestions from "./DomainSuggestions";
import {
  notifyInfo,
  notifySuccess,
  notifyWarning,
} from "components/ToastMessage";
import {
  addDomainBundleToCart,
  addDomainForwarderToCart,
  addDomainToCart,
  addPremiumToCart,
  // addPromo,
  addPromoDomain,
  addWhoisToCart,
  changeDomainFromCart,
  removeCartItem,
} from "features/common/layouts/cartSlice";
import {
  handleCLickCheckbox,
  handleSelectDuration,
  saveNameservers,
} from "features/domain/domainsSlice";
import { extractDomainName, getOnlyTLD } from "helpers/helper";
import { formatIDR } from "helpers/utils";
import { useEffect, useState } from "react";
import { OverlayTrigger, Tooltip, Button } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import Spinner from "react-bootstrap/Spinner";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
// import custom from "../../assets/scss/SuccessDomain.module.scss"; // File sudah dihapus
import { getIsFreeDomain as getIsFreeDomainHelper, hasFreeDomainInCart } from "../../helpers/helpersSuccessDomain";

const SuccessDomainRegister = (props) => {
  const { extensions = [], mode, promoDomains, onToggleDomainSections } = props;
  const dispatch = useDispatch();
  const location = useLocation();
  const {
    freeWhois: stateFreeWhois,
    premium_status: isPremium,
    premium_price: premiumPrice,
    status,
    domain_register: results,
  } = useSelector((state) => state.domain);

  // console.log(results, "results");

  const { productsList: cartItems, domainBundle: domainBundleOrder } =
    useSelector((state) => state.cart);
  // const { freeDomainExtensions } = useSelector((state) => state.hosting);
  // const [whois, setWhois] = useState("30000");
  const [whoisChecked, setWhoisChecked] = useState(false);
  const [isFreeWhois, setFreeWhois] = useState(false);
  const [domainWhois, setDomainWhois] = useState([]);
  const [showNameserver, setModalNameserver] = useState(false);
  const [nameservers, setNameservers] = useState(["", "", "", ""]);
  const [domainName, setDomainName] = useState("");
  const [bundleDomain, setBundleDomain] = useState(false);
  const [modalBundleDomain, setModalBundleDomain] = useState(false);
  const [cycleDomain, setCycleDomain] = useState(true);
  const [domainAi, setDomainAi] = useState(false);
  const [infoDonuts, setInfoDonuts] = useState(true);
  // const [isDiskon, setIsDiskon] = useState(false);
  const [showPromoCheckbox, setShowPromoCheckbox] = useState(false);
  const [isPromoChecked, setIsPromoChecked] = useState(false);
  const [durations, setDurations] = useState({});
  const [extensionPrices, setExtensionPrices] = useState({});
  const [tldPromoData, setTldPromoData] = useState({});
  const [kemerdekaanPromo, setKemerdekaanPromo] = useState(false);
  const [premiumDomainData, setPremiumDomainData] = useState({}); // Store premium domain data: { domain: { is_premium, public_price, registrar_price } }

  // const query = useQuery();
  // const domainRegister = query?.domainregister;

  // const debug = query?.debug === "true";
  const date = new Date();

  const { domain } = results[0] ?? { domain: "", duration: 0 };

  // Gunakan helper function untuk menentukan apakah domain gratis
  const getIsFreeDomain = (domain, duration, cartItems, isTransfer = false) => {
    return getIsFreeDomainHelper(domain, duration, cartItems, isTransfer);
  };

  useEffect(() => {
    const options = extensions.map(function (option) {
      return option[1];
    });

    if (domain && extensions) {
      setDomainName(extractDomainName(domain, options));
      // } else if (domainRegister && extensions) {
      //   setDomainName(extractDomainName(domainRegister, options));
    }
  }, [domain, extensions]);

  useEffect(() => {
    let hasBundleDomain = false;
    cartItems.forEach((result) => {
      const { domainForwarder = false, activateLater = false } = result;
      if (domainForwarder || domainBundleOrder.onlineId || activateLater) {
        hasBundleDomain = true;
        return;
      }
    });

    if (cartItems.length > 0) {
      setBundleDomain(hasBundleDomain);
    }
  }, [cartItems, domainBundleOrder]);

  const addDomainToCartHandler = (params) => {
    const availableDomains = results.filter(
      (result) => result.status === "available"
    );

    // Check if there's already a free domain in cart (register OR transfer)
    const hasFreeDomainInCartCheck = hasFreeDomainInCart(cartItems);

    availableDomains.forEach((result, i) => {
      const { domain, status, state_whois } = result;
      const premiumData = premiumDomainData[domain]; // Get premium domain data
      const isPremiumDomain = premiumData && premiumData.is_premium && domain.endsWith(".id");
      
      // Set default duration: 2 for .ai domains, 1 for premium .id domains, otherwise from durations or default to 1
      let selectedDuration = durations[domain];
      if (!selectedDuration) {
        if (domain.endsWith(".ai")) {
          selectedDuration = "2";
        } else if (isPremiumDomain) {
          selectedDuration = "1"; // Premium domains are always 1 year
        } else {
          selectedDuration = "1";
        }
      }
      
      // Force duration to "1" for premium domains
      if (isPremiumDomain) {
        selectedDuration = "1";
      }

      const extension = domain.substring(domain.indexOf("."));
      const prices = extensionPrices[extension];
      const tldPromo = tldPromoData[extension];

      const currentDomainChart = cartItems.find(
        (list) => list.domain === domain
      );

      if (currentDomainChart) {
        if (bundleDomain && params?.domainForwarder) {
          dispatch(
            addDomainForwarderToCart({
              domain,
              domainForwarder: params.domainForwarder,
            })
          );
        }

        if (bundleDomain && params?.activateLater !== undefined) {
          dispatch(
            addDomainForwarderToCart({
              domain,
              activateLater: params.activateLater,
              addActivate: true,
            })
          );
        }
        notifyWarning("Domain Anda sudah berada di dalam keranjang.");
        return;
      }

      notifySuccess("Domain berhasil ditambahkan ke keranjang.");

      // Map duration to corresponding price field
      const priceMap = {
        1: prices?.msetupfee,
        2: prices?.qsetupfee,
        3: prices?.ssetupfee,
        4: prices?.asetupfee,
        5: prices?.bsetupfee,
        6: prices?.monthly,
        7: prices?.quarterly,
        8: prices?.semiannually,
        9: prices?.annually,
        10: prices?.biennially,
      };

      // Get price based on selected duration and TLD promo logic
      let finalPrice = 0;

      // Check if domain is premium domain (.id only) - use public_price
      if (premiumData && premiumData.is_premium && domain.endsWith(".id")) {
        // Domain premium: use public_price from domain_premium table
        finalPrice = premiumData.public_price;
      } else {
        // Check if domain should be free based on all conditions
        const isFree = getIsFreeDomain(domain, selectedDuration, cartItems);

        // Only make domain free if there's no free domain in cart yet
        if (isFree && !hasFreeDomainInCartCheck) {
          finalPrice = 0;
        } else if (kemerdekaanPromo && domain.endsWith(".id") && selectedDuration === "1") {
          // Handle Kemerdekaan promo case for .id domains
          finalPrice = 50000;
        } else if (promoDomains && promoDomains.includes(domain) && selectedDuration === "1") {
          // Handle promo domain case (1 tahun)
          finalPrice = 100000;
        } else if (domain.endsWith(".ai") || domainAi) {
          // Handle .ai domain special case
          const twoYearPrice = parseFloat(prices?.qsetupfee || priceMap[selectedDuration] || 0);
          finalPrice = tldPromo ? tldPromo.hargapromo : twoYearPrice;
        } else if (parseInt(selectedDuration, 10) > 1) {
          // Handle regular domain pricing for duration > 1 (menggunakan msetupfee)
          finalPrice = parseFloat(priceMap[selectedDuration] || 0);
        } else if (selectedDuration === "1" && tldPromo) {
          // Default case for 1-year domains - gunakan API getTLDPromo.php
          finalPrice = tldPromo.hargapromo;
        } else {
          // Fallback jika tidak ada data TLD promo - gunakan harga asli dari result.price
          finalPrice = parseFloat(result.price || 0);
        }
      }

      dispatch(
        addDomainToCart({
          name: domain,
          status: status,
          domain: domain,
          price: finalPrice,
          priceRenew: finalPrice,
          type: "register",
          duration: selectedDuration,
          isWhois: isFreeWhois === true ? false : state_whois,
          freeWhois: isFreeWhois,
          domainForwarder: bundleDomain ? params?.domainForwarder : null,
          activateLater: bundleDomain ? params?.activateLater : null,
        })
      );

      if (whoisChecked) {
        dispatch(
          addWhoisToCart({
            domainWhois: domain,
            name: "Whois Protection",
            price: 30000,
            whois: domain + "," + 30000,
            freeWhois: isFreeWhois,
            type: "whois",
          })
        );
      }

      // Only add "Biaya One Time" for premium domains from API (isPremium), not from domain_premium table
      // Premium domains from domain_premium table already include one-time fee in public_price
      if (isPremium && premiumPrice !== 0 && !isPremiumDomain) {
        dispatch(
          addPremiumToCart({
            name: "Biaya One Time",
            price: premiumPrice,
            type: "Premium Domain",
            premium_domain: domain,
          })
        );
      }

      if (result.promocode) {
        dispatch(
          addPromoDomain({ promocode: result.promocode, price: 250000 - 18000 })
        );
      }
    });
  };

  const handleWhois = (e, freeWhois) => {
    setWhoisChecked(e.target.checked);
    dispatch(handleCLickCheckbox([e.target.value, e.target.checked]));
    setFreeWhois(freeWhois);
    setDomainWhois((prevState) => {
      const newState = [...prevState, e.target.value];
      return newState;
    });

    const checkWhois = cartItems.find((list) => list.domain === e.target.value);
    if (e.target.checked === true && checkWhois) {
      dispatch(
        addWhoisToCart({
          domainWhois: e.target.value,
          name: "Whois Protection",
          price: 30000,
          freeWhois: freeWhois,
          whois: e.target.value + "," + 30000,
          type: "whois",
        })
      );
    } else {
      dispatch(removeCartItem(e.target.value + "," + 30000));
    }
  };

  const fetchDomainPrices = async (extension) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_API}order/apis/get-price-domain.php?tipedomain=domainregister&extension=${extension}`
      );
      const data = await response.json();
      if (data.message === "success" && data.data.length > 0) {
        setExtensionPrices((prev) => ({
          ...prev,
          [extension]: data.data[0],
        }));
      }
    } catch (error) {
      console.error("Error fetching domain prices:", error);
    }
  };

  const fetchTldPromoData = async (extensions) => {
    try {
      const extensionsList = extensions.join(',');
      const response = await fetch(
        `${process.env.REACT_APP_BASE_API}apis/getTLDPromo.php?ext=${extensionsList}`
      );
      const data = await response.json();

      // Convert array to object for easier lookup
      const promoMap = {};
      data.forEach(item => {
        promoMap[item.extension] = {
          harganormal: parseFloat(item.harganormal.replace(/\./g, '')),
          hargapromo: parseFloat(item.hargapromo.replace(/\./g, ''))
        };
      });

      // console.log('TLD Promo Data fetched:', promoMap);
      setTldPromoData(promoMap);
    } catch (error) {
      console.error("Error fetching TLD promo data:", error);
    }
  };

  const fetchPremiumDomainData = async (domain) => {
    try {
      // Only check for .id domains
      if (!domain.endsWith('.id')) {
        return;
      }

      const response = await fetch(
        `${process.env.REACT_APP_BASE_API}order/apis/checkDomainPremium.php?domain=${encodeURIComponent(domain)}`
      );
      const data = await response.json();

      if (data.code === 200 && data.is_premium && data.data) {
        setPremiumDomainData((prev) => ({
          ...prev,
          [domain]: {
            is_premium: true,
            public_price: data.data.public_price,
            registrar_price: data.data.registrar_price,
            character_count: data.data.character_count
          }
        }));
      } else {
        // Domain bukan premium, set false
        setPremiumDomainData((prev) => ({
          ...prev,
          [domain]: {
            is_premium: false,
            public_price: null,
            registrar_price: null,
            character_count: null
          }
        }));
      }
    } catch (error) {
      console.error("Error fetching premium domain data:", error);
      // Set false on error
      setPremiumDomainData((prev) => ({
        ...prev,
        [domain]: {
          is_premium: false,
          public_price: null,
          registrar_price: null,
          character_count: null
        }
      }));
    }
  };

  const renderDurationOptions = (domain) => {
    const extension = domain.substring(domain.indexOf("."));
    const prices = extensionPrices[extension];
    const premiumData = premiumDomainData[domain];

    // Special case for premium .id domains - only 1 year
    if (premiumData && premiumData.is_premium && domain.endsWith(".id")) {
      return (
        <option key="1" value="1">
          1 Tahun
        </option>
      );
    }

    if (!prices) return null;

    // Special case for .ai domains
    if (extension === ".ai" || domainAi) {
      return (
        <option key="2" value="2">
          2 Tahun
        </option>
      );
    }

    const priceMap = {
      1: prices.msetupfee,
      2: prices.qsetupfee,
      3: prices.ssetupfee,
      4: prices.asetupfee,
      5: prices.bsetupfee,
      6: prices.monthly,
      7: prices.quarterly,
      8: prices.semiannually,
      9: prices.annually,
      10: prices.biennially,
    };

    // Only show options if triennially is "0.00" and the price is not "-1"
    if (prices.triennially !== "0.00") return null;

    return Object.entries(priceMap).map(([years, price]) => {
      if (price === "-1.00" || price === "-1") return null;
      return (
        <option key={years} value={years}>
          {years} Tahun
        </option>
      );
    });
  };

  const handleDurationChange = (e) => {
    const durationSelected = e.target.value;
    const domain = e.target.id;
    const extension = domain.substring(domain.indexOf("."));
    const prices = extensionPrices[extension];
    const tldPromo = tldPromoData[extension];
    const premiumData = premiumDomainData[domain]; // Get premium domain data
    
    // Don't allow duration change for premium domains - they are always 1 year
    const isPremiumDomain = premiumData && premiumData.is_premium && domain.endsWith(".id");
    if (isPremiumDomain) {
      return; // Prevent duration change for premium domains
    }

    // Update the duration for the specific domain
    setDurations((prevDurations) => ({
      ...prevDurations,
      [domain]: durationSelected,
    }));

    const checkDomain = cartItems.find((list) => list.domain === domain);
    if (checkDomain && prices) {
      const availableDomains = results.filter(
        (result) => result.status === "available"
      );

      availableDomains.forEach((result) => {
        const { status, state_whois } = result;

        // Map duration to corresponding price field
        const priceMap = {
          1: prices?.msetupfee,
          2: prices?.qsetupfee,
          3: prices?.ssetupfee,
          4: prices?.asetupfee,
          5: prices?.bsetupfee,
          6: prices?.monthly,
          7: prices?.quarterly,
          8: prices?.semiannually,
          9: prices?.annually,
          10: prices?.biennially,
        };

        // Get price based on selected duration and TLD promo logic
        let finalPrice = 0;

        // Check if domain is premium domain (.id only) - use public_price
        if (premiumData && premiumData.is_premium && domain.endsWith(".id")) {
          // Domain premium: use public_price from domain_premium table
          finalPrice = premiumData.public_price;
        } else {
          // Check if domain should be free based on all conditions
          const isFree = getIsFreeDomain(domain, durationSelected, cartItems);
          const hasExistingFreeDomain = hasFreeDomainInCart(cartItems);

          if (isFree && !hasExistingFreeDomain) {
            finalPrice = 0;
          } else if (kemerdekaanPromo && domain.endsWith(".id") && durationSelected === "1") {
            // Handle Kemerdekaan promo case for .id domains
            finalPrice = 50000;
          } else if (promoDomains && promoDomains.includes(domain) && durationSelected === "1") {
            // Handle promo domain case (1 tahun)
            finalPrice = 100000;
          } else if (domain.endsWith(".ai") || domainAi) {
            // Handle .ai domain special case
            const twoYearPrice = parseFloat(prices?.qsetupfee || priceMap[durationSelected] || 0);
            finalPrice = tldPromo ? tldPromo.hargapromo : twoYearPrice;
          } else if (parseInt(durationSelected, 10) > 1) {
            // Handle regular domain pricing for duration > 1 (menggunakan msetupfee)
            finalPrice = parseFloat(priceMap[durationSelected] || 0);
          } else if (durationSelected === "1" && tldPromo) {
            // Default case for 1-year domains - gunakan API getTLDPromo.php
            finalPrice = tldPromo.hargapromo;
          } else {
            // Fallback jika tidak ada data TLD promo - gunakan harga asli dari result.price
            finalPrice = parseFloat(result.price || 0);
          }
        }

        dispatch(
          changeDomainFromCart({
            name: domain,
            price: finalPrice,
            status: status,
            domain: domain,
            duration: durationSelected,
            priceRenew: finalPrice,
            type: "register",
            isWhois: isFreeWhois === true ? false : state_whois,
            freeWhois: isFreeWhois,
          })
        );
      });
    }

    dispatch(handleSelectDuration([domain, durationSelected]));
  };

  useEffect(() => {
    if (results && results.length > 0) {
      results.forEach((result) => {
        if (result.status === "available") {
          const extension = result.domain.substring(result.domain.indexOf("."));
          if (!extensionPrices[extension]) {
            fetchDomainPrices(extension);
          }
        }
      });
    }
  }, [extensionPrices, results]);

  const saveNameserver = (e) => {
    e.preventDefault();
    dispatch(
      saveNameservers([
        nameservers[0],
        nameservers[1],
        nameservers[2],
        nameservers[3],
      ])
    );
  };

  const bundleDomainHandler = (e) => {
    const bundledChecked = e.target?.checked;
    setBundleDomain(bundledChecked);
  };

  const modalBundleDomainHandler = () => {
    setModalBundleDomain(!modalBundleDomain);
  };

  const modalBundleDomainSubmit = (bundleData) => {
    addDomainToCartHandler(bundleData);
    modalBundleDomainHandler();

    dispatch(addDomainBundleToCart(bundleData));
  };

  useEffect(() => {
    const availableDomains = results.filter(
      (result) => result.status === "available"
    );
    const isWhois = availableDomains.some((result) => result.freeWhois);

    if (isWhois) {
      const domains = availableDomains.map((result) => result.domain);
      setFreeWhois(isWhois);
      setWhoisChecked(isWhois);
      setDomainWhois((prevState) => [...prevState, ...domains]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stateFreeWhois]);

  useEffect(() => {
    const availableDomains = results.filter(
      (result) => result.status === "available"
    );
    if (availableDomains) {
      let ext = "";
      let domainNotDonuts = [
        ".id",
        ".com",
        ".net",
        ".org",
        ".web.id",
        ".co.id",
        ".ponpes.id",
        ".sch.id",
        ".ac.id",
        ".biz.id",
        ".co.id",
        ".my.id",
        ".or.id",
      ];
      let aiDomain = [".ai"];
      availableDomains.forEach((result, i) => {
        let splitDomain = result.domain.split(".");
        if (splitDomain.length > 2) {
          ext = "." + splitDomain[1] + "." + splitDomain[2];
        } else {
          ext = "." + splitDomain[1];
        }
      });

      if (domainNotDonuts.includes(ext)) {
        setCycleDomain(false);
        setInfoDonuts(false);
        // setIsDiskon(false);
        setDomainAi(false);
      } else if (aiDomain.includes(ext)) {
        setCycleDomain(true);
        setInfoDonuts(false);
        // setIsDiskon(false);
        setDomainAi(true);
      } else {
        setCycleDomain(true);
        setInfoDonuts(true);
        // setIsDiskon(false);
        setDomainAi(false);
      }
    }
  }, [results]);

  useEffect(() => {
    const availableDomains = results.filter(
      (result) => result.status === "available"
    );
    if (availableDomains) {
      let ext = "";
      availableDomains.forEach((result) => {
        let splitDomain = result.domain.split(".");
        if (splitDomain.length > 2) {
          ext = "." + splitDomain[1] + "." + splitDomain[2];
        } else {
          ext = "." + splitDomain[1];
        }
      });

      // Check promo period for Flex WP
      const promoEndDate = new Date("2025-04-04T23:59:00+07:00");
      const currentDate = new Date();
      const isWithinPromoPeriod = currentDate <= promoEndDate;

      // Check Kemerdekaan promo period (17-18 Agustus 2025)
      const kemerdekaanStartDate = new Date("2025-08-17T00:00:00+07:00");
      const kemerdekaanEndDate = new Date("2025-08-18T06:59:59+07:00");
      const isWithinKemerdekaanPeriod = currentDate >= kemerdekaanStartDate && currentDate <= kemerdekaanEndDate;

      // Only show promo checkbox if within promo period and has valid extension
      if (
        (ext === ".id" || ext === ".com") &&
        location.pathname === "/orderdomain" &&
        isWithinPromoPeriod
      ) {
        setShowPromoCheckbox(true);
      } else {
        setShowPromoCheckbox(false);
      }

      // Set Kemerdekaan promo flag for .id domains
      if (ext === ".id" && isWithinKemerdekaanPeriod) {
        setKemerdekaanPromo(true);
      } else {
        setKemerdekaanPromo(false);
      }
    }
  }, [results, location.pathname]);

  const navigate = useNavigate();

  // const hasHostingOrOtherServices = cartItems.some(
  //   (item) =>
  //     item.type === "hostingaccount" ||
  //     item.type === "server" ||
  //     item.type === "emailSuite" ||
  //     item.type === "vpn" ||
  //     item.type === "digitalSignature"
  // );

  const handlePromoCheckboxChange = (e) => {
    const isChecked = e.target.checked;
    setIsPromoChecked(isChecked);

    if (isChecked) {
      // Assuming you want to pass the first available domain from results
      const domainDetails = results.find(
        (result) => result.status === "available"
      );

      const whoisDetails = whoisChecked
        ? domainWhois.map((domain) => ({
          domainWhois: domain,
          name: "Whois Protection",
          price: isFreeWhois ? "0" : 30000,
          whois: domain + "," + 30000,
          freeWhois: isFreeWhois,
          type: "whois",
        }))
        : [];

      if (domainDetails) {
        notifyInfo("Promo sedang diproses, Mohon tunggu...");

        setTimeout(() => {
          navigate("/orderhosting?pid=1117&billingcycle=annually", {
            state: {
              fromSuccessDomainRegister: true,
              domainDetails,
              whoisDetails,
            },
          });
        }, 5000);
      }
    } else {
      dispatch(removeCartItem(1117));
    }
  };

  // Filter results based on mode
  const filteredResults = results.filter((result, index) => {
    if (results.length === 1) {
      return true; // Automatically switch to single mode if only one domain
    } else if (mode === "single") {
      return results.length === 1;
    } else if (mode === "multiple") {
      return results.length > 1;
    }
    return false;
  });

  // Check if any domain is available
  const hasAvailableDomain = filteredResults.some(result => result.status === "available");

  // Handle "Isi Domain Nanti" button click
  const handleIsiDomainNanti = () => {
    if (onToggleDomainSections && typeof onToggleDomainSections === 'function') {
      // Hide the domain sections permanently
      onToggleDomainSections(false);
    } else {
      // Jika onToggleDomainSections tidak ada, hanya tampilkan notifikasi
      notifyInfo("Anda dapat menambahkan domain nanti di halaman checkout.");
    }
  };

  useEffect(() => {
    // Cek jika ada hostingaccount dengan billingcycle biennially di cart
    const hasBiennialHosting = cartItems.some(
      (item) =>
        item.type === "hostingaccount" &&
        (item.billingcycle === "biennially" || item.billingcycle === "2tahun" || item.billingcycle === "2 tahun")
    );

    // Cek jika ada free domain di cart (register OR transfer)
    const hasFreeDomain = hasFreeDomainInCart(cartItems);

    if (
      hasBiennialHosting &&
      !hasFreeDomain &&
      results &&
      results.length > 0
    ) {
      // Set hanya jika durations[domain] belum ada (user belum memilih manual)
      // Skip premium domains - they are always 1 year
      const availableDomains = results.filter((result) => {
        if (result.status !== "available") return false;
        const premiumData = premiumDomainData[result.domain];
        const isPremiumDomain = premiumData && premiumData.is_premium && result.domain.endsWith(".id");
        return !isPremiumDomain; // Exclude premium domains
      });
      
      const newDurations = {};
      availableDomains.forEach((result) => {
        if (!durations[result.domain]) {
          newDurations[result.domain] = "2";
        }
      });
      if (Object.keys(newDurations).length > 0) {
        setDurations((prev) => ({ ...prev, ...newDurations }));
      }
    }
    // Jika tidak, biarkan durations tetap (user bisa pilih manual)
    // Tidak perlu reset ke 1 tahun jika user sudah memilih
  }, [cartItems, results, durations, premiumDomainData]);

  // Fetch TLD promo data when results change
  useEffect(() => {
    if (results && results.length > 0) {
      const extensions = results.map(result => {
        return result.domain.substring(result.domain.indexOf('.'));
      });

      // Remove duplicates
      const uniqueExtensions = [...new Set(extensions)];

      if (uniqueExtensions.length > 0) {
        fetchTldPromoData(uniqueExtensions);
      }
    }
  }, [results]);

  // Fetch premium domain data when results change (only for .id domains)
  useEffect(() => {
    if (results && results.length > 0) {
      results.forEach((result) => {
        if (result.status === "available" && result.domain.endsWith(".id")) {
          // Only fetch if not already fetched or if data is not premium
          const existingData = premiumDomainData[result.domain];
          if (!existingData || existingData.is_premium === undefined) {
            fetchPremiumDomainData(result.domain);
          }
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [results]);

  // Set duration to "1" for premium domains when premium data is available
  useEffect(() => {
    if (results && results.length > 0 && Object.keys(premiumDomainData).length > 0) {
      const newDurations = {};
      results.forEach((result) => {
        if (result.status === "available") {
          const premiumData = premiumDomainData[result.domain];
          const isPremiumDomain = premiumData && premiumData.is_premium && result.domain.endsWith(".id");
          
          if (isPremiumDomain) {
            // Force duration to "1" for premium domains
            newDurations[result.domain] = "1";
          }
        }
      });
      
      if (Object.keys(newDurations).length > 0) {
        setDurations((prev) => ({ ...prev, ...newDurations }));
      }
    }
  }, [premiumDomainData, results]);

  // Auto-open domain sections when available domains are found - DISABLED
  // useEffect(() => {
  //   if (hasAvailableDomain && onToggleDomainSections) {
  //     onToggleDomainSections(true); // Open domain sections
  //   }
  // }, [hasAvailableDomain, onToggleDomainSections]);

  return (
    <div className="container-fluid">
      <div className="row justify-content-center">
        <div className="col-12 col-lg-12">
          {status === "loading" && (
            <div className="text-center my-5">
              <Spinner animation="border" />
            </div>
          )}
          {status === "error" && (
            <div>An error occurred. Please try again later.</div>
          )}
          {status === "fulfilled" && (
            <>
              {/* {console.log(filteredResults, "filteredResults")} */}
              {filteredResults.map((result, i) => (
                <div key={i}>
                  {result.status === "available" && (
                    <div
                      className={`container pb-0 ${location.pathname === "/orderhosting"
                        ? "ps-5"
                        : "ps-5 pe-2"
                        }`}
                    >
                      <div
                        className={`row ${result.domain.split(".")[1] === "id" &&
                          date >= new Date("2023-12-31T17:00:00")
                          ? "my-2"
                          : "my-4"
                          } justify-content-between`}
                      >
                        <div
                          className={`col-12 col-lg-8 pe-0 ${result.domain.split(".")[1] === "id" &&
                            date >= new Date("2023-12-31T17:00:00")
                            ? "align-self-center"
                            : ""
                            }`}
                        >
                          <div className="row g-2">
                            <div className="col-12 col-md-6 d-flex align-items-center mb-2 mb-md-0 flex-wrap gap-2">
                              <p
                                className="mb-0 fw-bold"
                                style={{ fontSize: "clamp(16px, 2vw, 18px)", color: "#ee4d30" }}
                              >
                                {result.domain}
                              </p>
                              {(() => {
                                const premiumData = premiumDomainData[result.domain];
                                const isDomainPremium = (premiumData && premiumData.is_premium) || (isPremium && premiumPrice !== 0);
                                
                                if (isDomainPremium && result.domain.endsWith(".id")) {
                                  return (
                                    <span
                                      className="badge"
                                      style={{ 
                                        fontSize: "clamp(10px, 1.2vw, 12px)", 
                                        fontWeight: "700",
                                        backgroundColor: "#ee4d30",
                                        color: "#fff",
                                        padding: "4px 8px",
                                        borderRadius: "4px"
                                      }}
                                    >
                                      Domain Premium
                                    </span>
                                  );
                                }
                                return null;
                              })()}
                            </div>

                            <div className="col-12 col-md-6 d-flex align-items-center">
                              {(() => {
                                const premiumData = premiumDomainData[result.domain];
                                const isPremiumDomain = premiumData && premiumData.is_premium && result.domain.endsWith(".id");
                                
                                return (
                                  <select
                                    className="form-select form-select-sm"
                                    style={{ fontSize: "clamp(12px, 1.5vw, 14px)", maxWidth: "150px" }}
                                    aria-label=".form-select-sm example"
                                    onChange={handleDurationChange}
                                    id={result.domain}
                                    disabled={cycleDomain || isPremiumDomain}
                                    value={durations[result.domain] || "1"}
                                  >
                                    {renderDurationOptions(result.domain)}
                                  </select>
                                );
                              })()}

                              {infoDonuts && (
                                <div className="ms-2">
                                  <OverlayTrigger
                                    placement={"right"}
                                    overlay={
                                      <Tooltip>
                                        Domain ini hanya dapat dipesan 1 tahun
                                      </Tooltip>
                                    }
                                  >
                                    <span
                                      className="d-inline-block px-2 py-0 fw-bold text-white"
                                      style={{
                                        backgroundColor: "#ee4d30",
                                        cursor: "pointer",
                                        borderRadius: "50%",
                                        fontSize: "clamp(10px, 1.2vw, 12px)",
                                      }}
                                    >
                                      i
                                    </span>
                                  </OverlayTrigger>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="col-12 col-lg-4 ps-0 text-end text-lg-end mt-3 mt-lg-0">
                          <div
                            className="mb-0 align-self-center fw-bold d-flex align-items-center justify-content-end gap-2"
                            style={{ fontSize: "18px" }}
                          >
                            <div className="d-flex flex-column align-items-end">
                            {(() => {
                              const isPromoDomain =
                                promoDomains &&
                                promoDomains.includes(result.domain);
                              const selectedDuration =
                                durations[result.domain] || "1";
                              const extension = result.domain.substring(
                                result.domain.indexOf(".")
                              );
                              const prices = extensionPrices[extension];
                              const tldPromo = tldPromoData[extension];
                              const premiumData = premiumDomainData[result.domain]; // Get premium domain data

                              // Map duration to corresponding price field
                              const priceMap = {
                                1: prices?.msetupfee,
                                2: prices?.qsetupfee,
                                3: prices?.ssetupfee,
                                4: prices?.asetupfee,
                                5: prices?.bsetupfee,
                                6: prices?.monthly,
                                7: prices?.quarterly,
                                8: prices?.semiannually,
                                9: prices?.annually,
                                10: prices?.biennially,
                              };

                              const priceFromMap = parseFloat(
                                priceMap[selectedDuration] || 0
                              );

                              // Check if domain is premium domain (.id only) - use public_price
                              if (premiumData && premiumData.is_premium && result.domain.endsWith(".id")) {
                                return (
                                  <div className="d-flex flex-column align-items-end">
                                    <span className="fw-bold" style={{ fontSize: "18px", color: "#ee4d30" }}>
                                      {formatIDR(premiumData.public_price)}
                                    </span>
                                  </div>
                                );
                              }

                              // Check if domain should be free based on all conditions
                              const isFree = getIsFreeDomain(
                                result.domain,
                                selectedDuration,
                                cartItems
                              );

                              // Check if there's already a free domain in cart (register OR transfer)
                              const hasFreeDomainInCartCheck = hasFreeDomainInCart(cartItems);

                              // 1. Handle free domain case (only for first domain)
                              if (isFree && !hasFreeDomainInCartCheck) {
                                return (
                                  <div className="d-flex flex-column align-items-end">
                                    <span className="text-muted small text-decoration-line-through fw-bold">
                                      {formatIDR(parseInt(result.price, 10))}
                                    </span>
                                    <div className="d-flex flex-column align-items-end">
                                      <span className="fw-bold">
                                        {formatIDR(0)}
                                      </span>
                                      <span className="badge bg-success text-white p-2 mt-1">
                                        GRATIS DOMAIN!
                                      </span>
                                    </div>
                                  </div>
                                );
                              }

                              // 2. Handle Kemerdekaan promo case for .id domains
                              if (kemerdekaanPromo && result.domain.endsWith(".id") && selectedDuration === "1") {
                                return (
                                  <>
                                    <span className="text-muted small text-decoration-line-through fw-bold">
                                      {/* {formatIDR(parseInt(result.price, 10))} */}
                                      {formatIDR(parseInt(250000))}
                                    </span>
                                    <div className="d-flex flex-column align-items-end">
                                      <span className="fw-bold">
                                        {formatIDR(50000)}
                                      </span>
                                      <span className="badge bg-danger text-white p-2 mt-1">
                                        PROMO SPESIAL!
                                      </span>
                                    </div>
                                  </>
                                );
                              }

                              // 3. Handle promo domain case (1 tahun)
                              if (isPromoDomain && selectedDuration === "1") {
                                return (
                                  <>
                                    <span className="text-muted small text-decoration-line-through fw-bold">
                                      {formatIDR(parseInt(result.price, 10))}
                                    </span>
                                    <div className="d-flex flex-column align-items-end">
                                      <span className="fw-bold">
                                        {formatIDR(100000)}
                                      </span>
                                      <span className="badge bg-warning text-dark p-2 mt-1">
                                        PROMO
                                      </span>
                                    </div>
                                  </>
                                );
                              }

                              // 3. Handle .ai domain special case
                              if (result.domain.endsWith(".ai") || domainAi) {
                                const twoYearPrice = parseFloat(
                                  prices?.qsetupfee || priceFromMap
                                );
                                const originalPrice = twoYearPrice;

                                // Untuk .ai domain, gunakan tldPromo jika ada, jika tidak gunakan fallback
                                let strikethroughPrice = originalPrice;
                                if (tldPromo && tldPromo.harganormal !== tldPromo.hargapromo) {
                                  strikethroughPrice = tldPromo.harganormal;
                                }

                                return (
                                  <>
                                    <span className="text-muted small text-decoration-line-through fw-bold">
                                      {formatIDR(strikethroughPrice)}
                                    </span>
                                    <div className="d-flex flex-column align-items-end">
                                      <span className="fw-bold">
                                        {formatIDR(tldPromo ? tldPromo.hargapromo : originalPrice)}
                                      </span>
                                      <span className="badge bg-warning text-dark p-2 mt-1">
                                        PROMO
                                      </span>
                                    </div>
                                  </>
                                );
                              }

                              // 4. Handle regular domain pricing for duration > 1 (menggunakan msetupfee)
                              if (parseInt(selectedDuration, 10) > 1) {
                                return formatIDR(priceFromMap);
                              }

                              // 5. Default case for 1-year domains - gunakan API getTLDPromo.php
                              if (tldPromo) {
                                const { harganormal, hargapromo } = tldPromo;

                                // Jika harga normal sama dengan harga promo, tidak ada strikethrough
                                if (harganormal === hargapromo) {
                                  return formatIDR(hargapromo);
                                }

                                // Jika berbeda, tampilkan dengan strikethrough
                                return (
                                  <>
                                    <span className="text-muted small text-decoration-line-through fw-bold">
                                      {formatIDR(harganormal)}
                                    </span>
                                    <div className="d-flex flex-column align-items-end">
                                      <span className="fw-bold">
                                        {formatIDR(hargapromo)}
                                      </span>
                                      <span className="badge bg-warning text-dark p-2 mt-1">
                                        PROMO
                                      </span>
                                    </div>
                                  </>
                                );
                              }

                              // 6. Fallback jika tidak ada data TLD promo - gunakan harga asli dari result.price
                              const priceInt = parseInt(result.price, 10);
                              return formatIDR(priceInt);
                            })()}
                            </div>
                            <Button
                              variant="outline-primary"
                              size="sm"
                              onClick={() => addDomainToCartHandler()}
                              style={{
                                width: "40px",
                                height: "40px",
                                borderRadius: "8px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                borderColor: "#ee4d30",
                                color: "#ee4d30",
                                flexShrink: 0
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = "#ee4d30";
                                e.currentTarget.style.color = "#fff";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = "transparent";
                                e.currentTarget.style.color = "#ee4d30";
                              }}
                            >
                              <FontAwesomeIcon icon={faPlus} />
                            </Button>
                          </div>
                        </div>
                      </div>

                      <div className="row my-4 justify-content-between align-items-start">
                        <div className="form-check col-12 col-lg-6">
                          <div className="flex-shrink-0">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              onChange={(e) => handleWhois(e, result.freeWhois)}
                              value={result.domain}
                              id={result.domain + "id"}
                              checked={whoisChecked}
                              style={{ marginTop: "2px" }}
                            />
                          </div>
                          <div className="flex-grow-1 ms-2">
                            <label
                              htmlFor={result.domain + "id"}
                              className="form-check-label fw-bold"
                              style={{ fontSize: "16px" }}
                            >
                              Whois Protection
                            </label>
                            <p className="text-muted small mb-0 mt-1">
                              Perlindungan domain dengan Whois Protection
                            </p>
                          </div>
                        </div>
                          <div
                            key={i}
                            className="col-12 col-lg-4 d-flex flex-column align-items-end"
                          >
                            {result.freeWhois ? (
                              <div className="d-flex flex-column align-items-end">
                                <span className="text-muted small text-decoration-line-through fw-bold">
                                  Rp30.000
                                </span>
                                <span className="badge bg-warning text-dark p-2 mt-1">GRATIS!</span>
                              </div>
                            ) : (
                            <p className="mb-0 fw-bold text-end small">Rp 30.000</p>
                            )}
                          </div>
                      </div>

                      {/* Biaya One Time - Only show for non-premium domain data (isPremium from API) */}
                      {/* Hide for premium domain from domain_premium table because price already includes one-time fee */}
                      {isPremium && premiumPrice !== 0 && !(premiumDomainData[result.domain] && premiumDomainData[result.domain].is_premium) && (
                        <div className="row mb-5 justify-content-between">
                          <div className="col-10 col-lg-6 d-flex align-items-center">
                            <p className="mb-0 text-primary fw-bold text-black" style={{ fontSize: "16px" }}>
                              Biaya One Time
                            </p>
                          </div>
                          <div className="col-2 col-lg-6 ps-0 text-end align-self-center">
                            {(() => {
                              const domainName = result.domain?.split(".")[0] || "";
                              let strikePrice = null;
                              let bestSeller = false;
                              
                              if (domainName.length === 2) strikePrice = 585000000;
                              if (domainName.length === 3) { strikePrice = 22000000; bestSeller = true; }
                              if (domainName.length === 4) strikePrice = 3500000;
                              
                              return (
                                <div className="d-flex flex-column align-items-end">
                                  {strikePrice && (
                                    <span className="text-muted small text-decoration-line-through fw-bold">
                                      {formatIDR(strikePrice)}
                                    </span>
                                  )}
                                  <span className="mb-0 fw-bold" style={{ fontSize: "18px", color: "#ee4d30" }}>
                                    {formatIDR(premiumPrice)}
                                  </span>
                                  {bestSeller && (
                                    <span className="badge" style={{ 
                                      backgroundColor: "#ee4d30", 
                                      color: "#fff",
                                      padding: "4px 8px",
                                      marginTop: "4px",
                                      fontSize: "12px",
                                      fontWeight: "700"
                                    }}>
                                      BEST SELLER
                                    </span>
                                  )}
                                </div>
                              );
                            })()}
                          </div>
                        </div>
                      )}

                      <div className="row my-4 justify-content-between align-items-start">
                        <div className="form-check col-12 col-lg-6">
                          <div className="flex-shrink-0">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              name="bundled_domain"
                              id="bundled_domain"
                              value="bundled_domain"
                              onChange={bundleDomainHandler}
                              checked={bundleDomain}
                              style={{ marginTop: "2px" }}
                            />
                          </div>
                          <div className="flex-grow-1 ms-2">
                            <label
                              htmlFor="bundled_domain"
                              className="form-check-label fw-bold"
                              style={{ fontSize: "16px" }}
                            >
                              Bundle Domain
                            </label>
                            <p className="text-muted small mb-0 mt-1">
                              Bundle Forward Domain, Online.id, dan WA Generator
                              (Optional)
                            </p>
                          </div>
                        </div>
                        <div className="col-12 col-lg-4 d-flex flex-column align-items-end mt-lg-2">
                          <span className="text-muted small text-decoration-line-through fw-bold">
                            Rp50.000
                          </span>
                          <span className="badge bg-warning text-dark p-2 mt-1">GRATIS!</span>
                        </div>
                      </div>

                      {/* Domain Suggestions Section - Show for all domains */}
                      <DomainSuggestions 
                        unavailableDomain={result.domain} 
                        extensions={extensions} 
                      />

                      {showPromoCheckbox &&
                        (getOnlyTLD(result.domain) === ".id" ||
                          getOnlyTLD(result.domain) === ".com") && (
                          <div className="row my-4 justify-content-between">
                            <div className="col-12 col-lg-8 d-flex">
                              <div className="form-check mb-3">
                                <div className="flex-shrink-0">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    name="promo_flex_wp"
                                    id="promo_flex_wp"
                                    value="promo_flex_wp"
                                    onChange={handlePromoCheckboxChange}
                                    checked={isPromoChecked}
                                    style={{ marginTop: "2px" }}
                                  />
                                </div>
                                <div className="flex-grow-1 ms-2">
                                  <label
                                    htmlFor="promo_flex_wp"
                                    className="form-check-label fw-bold"
                                    style={{ fontSize: "16px" }}
                                  >
                                    Promo Hosting untuk Domain .ID dan .COM
                                  </label>
                                  <p
                                    className="text-muted small mb-0 mt-1"
                                    style={{ fontSize: "14px" }}
                                  >
                                    Free Hosting Flex WP (1 Tahun)
                                  </p>
                                </div>
                                {/* <p
                                className="ms-3 form-check-label mt-1"
                                style={{ fontSize: "14px" }}
                              >
                                Note: Wajib mengecek Voucher di halaman berikutnya untuk klaim Kode Voucher
                              </p> */}
                              </div>
                            </div>
                            <div className="col-12 col-lg-4 d-flex flex-column align-items-end">
                              <span className="text-muted small text-decoration-line-through fw-bold">
                                Rp180.000
                              </span>
                              <span className="badge bg-warning text-dark p-2 mt-1">
                                GRATIS!
                              </span>
                            </div>
                          </div>
                        )}

                      {results.length < 2 && <></>}
                      {results.length > 1 && !results[1].nameserver1 && (
                        <hr className="mb-1 mt-1" />
                      )}
                    </div>
                  )}

                  {result.status === "not-available" && (
                    <div className="my-3">
                      <h5 className="text-danger bg-danger-subtle text-center rounded p-2">
                        {result.domain} tidak tersedia
                      </h5>
                      {/* Show domain suggestions for unavailable domain */}
                      <DomainSuggestions 
                        unavailableDomain={result.domain} 
                        extensions={extensions}
                      />
                      {results.length < 2 && <></>}
                      {results.length > 1 && !results[1].nameserver1 && (
                        <hr
                          className="mb-5 mt-5"
                          style={{
                            backgroundColor: "transparent",
                            borderRadius: "0px",
                            color: "rgb(33, 37, 41)",
                          }}
                        />
                      )}
                    </div>
                  )}

                  {result.status === "error" && (
                    <div className="my-3">
                      <h5 className="text-danger bg-danger-subtle text-center rounded p-2">
                        {result.domain} Tidak tersedia
                      </h5>
                      {/* Show domain suggestions for unavailable domain */}
                      <DomainSuggestions 
                        unavailableDomain={result.domain} 
                        extensions={extensions}
                      />
                      {results.length < 2 && <></>}
                      {results.length > 1 && !results[1].nameserver1 && (
                        <hr
                          className="mb-5 mt-5"
                          style={{
                            backgroundColor: "transparent",
                            borderRadius: "0px",
                            color: "rgb(33, 37, 41)",
                          }}
                        />
                      )}
                    </div>
                  )}
                </div>
              ))}

              <div className="row mt-5 mb-4">
                <div className="col-12">
                  <div className="d-flex flex-column flex-lg-row justify-content-between justify-content-lg-between align-items-center gap-3">
                    <button
                      type="button"
                      className="btn btn-outline-secondary px-4 rounded-5"
                      onClick={() => setModalNameserver(true)}
                    >
                      Ubah Nameserver default
                    </button>

                    <button
                      type="button"
                      className="btn btn-cta px-4 rounded-5"
                      onClick={
                        hasAvailableDomain
                          ? bundleDomain
                            ? modalBundleDomainHandler
                            : addDomainToCartHandler
                          : handleIsiDomainNanti
                      }
                      disabled={
                        !hasAvailableDomain && location.pathname === "/orderdomain"
                      }
                    >
                      {hasAvailableDomain ? "Tambahkan ke Keranjang" : "Isi Domain Nanti"}
                    </button>
                  </div>
                </div>
              </div>

              {/* Modal for nameserver click */}
              <Modal
                show={showNameserver}
                onHide={() => setModalNameserver(false)}
                backdrop="static"
                keyboard={false}
                size="sm"
                aria-labelledby="example-custom-modal-styling-title"
                centered
              >
                <Modal.Header closeButton>
                  <Modal.Title id="example-custom-modal-styling-title">
                    Nameserver
                  </Modal.Title>
                </Modal.Header>
                <form onSubmit={saveNameserver}>
                  <Modal.Body>
                    {[1, 2, 3, 4].map((num) => (
                      <div className="mb-3" key={num}>
                        <label
                          htmlFor={`nameserver${num}`}
                          className="form-label label-qwords"
                        >
                          {`Nameserver ${num}`}
                        </label>
                        <input
                          type="text"
                          className="form-control input-modal"
                          id={`nameserver${num}`}
                          placeholder={`dns${num}.qwords.net`}
                          value={nameservers[num - 1] || ""}
                          onChange={(e) => {
                            const newNameservers = [...nameservers];
                            newNameservers[num - 1] = e.target.value;
                            setNameservers(newNameservers);
                          }}
                        />
                      </div>
                    ))}
                  </Modal.Body>
                  <Modal.Footer>
                    <button
                      className="btn btn-cta w-100"
                      type="submit"
                      onClick={(e) => {
                        e.preventDefault();
                        saveNameserver(e);
                        notifySuccess("Nameserver berhasil disimpan!");
                        setModalNameserver(false);
                        }}
                    >
                      Simpan
                    </button>
                  </Modal.Footer>
                </form>
              </Modal>

              <ModalBundleDomain
                show={modalBundleDomain}
                onHide={modalBundleDomainHandler}
                onFormSubmited={modalBundleDomainSubmit}
                defaultOnlineId={domainName}
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default SuccessDomainRegister;
